// noinspection JSUnresolvedVariable

import Vue from "vue"

const AUTH = "_allauth/browser/v1/auth"
const ACCOUNT = "_allauth/browser/v1/account"
const LOGIN_URL = `${AUTH}/login`
const PROVIDER_REDIRECT_URL = `${AUTH}/provider/redirect`
const GET_SESSION_URL = `${AUTH}/session`
const LOGOUT_URL = `${AUTH}/session`
const PASSWORD_CHANGE_URL = `${ACCOUNT}/password/change`
const PASSWORD_RESET_URL = `${AUTH}/password/request`
const PASSWORD_RESET_CONFIRM_URL = `${AUTH}/password/reset`
const VERIFY_EMAIL_URL = `${AUTH}/email/verify`
const CSRF_TOKEN_URL = "csrf-token/"

const MY_PROFILE_URL = "users/me/"

const IMPERSONATE_ACQUIRE_URL = "impersonate/acquire/"
const IMPERSONATE_RELEASE_URL = "impersonate/release/"

export default {
  async changePassword(current_password, new_password) {
    const data = { current_password, new_password }

    try {
      return await Vue.axios.post(PASSWORD_CHANGE_URL, data)
    } catch (error) {
      return error.response
    }
  },

  async login(data) {
    //this request needs CSRF cookie to be set, but we have not received it
    //axios will set it automatically after receiving the response to getCSRFCookie
    await this.getCSRFCookie()
    if (Vue.axios.defaults.headers.common["Authorization"])
      delete Vue.axios.defaults.headers.common["Authorization"]

    try {
      return await Vue.axios.post(LOGIN_URL, data)
    } catch (error) {
      return error.response
    }
  },

  async getCSRFCookie() {
    let csrfCookieValue = null
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";")
      for (let cookie of cookies) {
        cookie = cookie.trim()
        // Does this cookie string begin with the name we want?
        const name = "csrftoken"
        if (cookie.substring(0, name.length + 1) === name + "=")
          csrfCookieValue = decodeURIComponent(cookie.substring(name.length + 1))
      }
    }
    if (!csrfCookieValue) {
      const response = await Vue.axios.get(CSRF_TOKEN_URL)
      if (response) csrfCookieValue = response.data?.csrfToken
    }

    return csrfCookieValue
  },

  async providerRedirect(process = "login") {
    const providerForm = document.createElement("form")
    providerForm.method = "POST"
    providerForm.action = `${window.location.protocol}//${window.location.host}/api/${PROVIDER_REDIRECT_URL}`

    // Add CSRF token if required
    const csrfCookie = await this.getCSRFCookie()
    if (csrfCookie) {
      const csrfInput = document.createElement("input")
      csrfInput.type = "hidden"
      csrfInput.name = "csrfmiddlewaretoken"
      csrfInput.value = csrfCookie
      providerForm.appendChild(csrfInput)
    }

    // Add provider
    const providerInput = document.createElement("input")
    providerInput.type = "hidden"
    providerInput.name = "provider"
    providerInput.value = "microsoft"
    //providerInput.value = "google"
    providerForm.appendChild(providerInput)

    // Add callback url
    const callbackUrlInput = document.createElement("input")
    callbackUrlInput.type = "hidden"
    callbackUrlInput.name = "callback_url"
    callbackUrlInput.value = `${window.location.protocol}//${window.location.host}/auth/provider-callback/`
    providerForm.appendChild(callbackUrlInput)

    // Add process
    const processInput = document.createElement("input")
    processInput.type = "hidden"
    processInput.name = "process"
    processInput.value = process
    providerForm.appendChild(processInput)

    // Submit providerForm (this will cause a page redirect)
    document.body.appendChild(providerForm)
    providerForm.submit()
  },

  async getSession() {
    try {
      return await Vue.axios.get(GET_SESSION_URL)
    } catch (error) {
      return error.response
    }
  },

  async logout() {
    try {
      console.error("Hello from api logout")
      return await Vue.axios.delete(LOGOUT_URL, {
        validateStatus: (status) => status === 401,
      })
    } catch (error) {
      console.error("Api logout error")
      return error.response
    }
  },

  async profile() {
    try {
      const profile = await Vue.axios.get(MY_PROFILE_URL)
      return profile
    } catch (error) {
      return error.response
    }
  },

  async reset(email) {
    //this request needs CSRF cookie to be set, but we have not received it
    //axios will set it automatically after receiving the response to getCSRFCookie
    await this.getCSRFCookie()
    if (Vue.axios.defaults.headers.common["Authorization"])
      delete Vue.axios.defaults.headers.common["Authorization"]

    try {
      return await Vue.axios.post(PASSWORD_RESET_URL, { email })
    } catch (error) {
      return error.response
    }
  },

  async resetConfirm(key, password) {
    //this request needs CSRF cookie to be set, but we have not received it
    //axios will set it automatically after receiving the response to getCSRFCookie
    await this.getCSRFCookie()
    const data = { key, password }
    try {
      return await Vue.axios.post(PASSWORD_RESET_CONFIRM_URL, data)
    } catch (error) {
      return error.response
    }
  },

  async getEmailVerification(key) {
    try {
      return await Vue.axios.get(VERIFY_EMAIL_URL, {
        headers: { "X-Email-Verification-Key": key },
      })
    } catch (error) {
      return error.response
    }
  },

  async verifyEmail(key) {
    //this request needs CSRF cookie to be set, but we have not received it
    //axios will set it automatically after receiving the response to getCSRFCookie
    await this.getCSRFCookie()
    const data = { key }
    try {
      return await Vue.axios.post(VERIFY_EMAIL_URL, data)
    } catch (error) {
      return error.response
    }
  },

  async validateMapshareToken(token) {
    Vue.axios.defaults.headers.common["MapShare"] = `Token ${token}`

    try {
      return await Vue.axios.get(`mapshares/${token}/`)
    } catch (error) {
      return error.response
    }
  },

  async impersonate(user) {
    const bodyFormData = new FormData()
    bodyFormData.append("user_pk", user)

    try {
      return await Vue.axios.post(IMPERSONATE_ACQUIRE_URL, bodyFormData)
    } catch (error) {
      return error.response
    }
  },

  async releaseImpersonate() {
    try {
      return await Vue.axios.post(IMPERSONATE_RELEASE_URL)
    } catch (error) {
      return error.response
    }
  },

  async updateUser() {
    try {
      return await Vue.axios.get(MY_PROFILE_URL)
    } catch (error) {
      return error.response
    }
  },
}
